import { TemplateEditor } from "../features/create/TemplateEditor";

export function CreatePage() {
  return <TemplateEditor />;
}
